// import React, { useState, useRef, useEffect } from "react";
// // import DropDownIcon from "../../Assets/Images/EployeeRegistration/icon-dropdown-menu.png";
// import DropDownIcon from "../../../Assets/Images/EployeeRegistration/icon-dropdown-menu.png";

// export default function SectionSelectedDropdown({
//   width,
//   label,
//   selected,
//   setSelected,
//   options,
//   customWidth,
//   customTop,
//   isRequired,
//   Height,
//   OverFlow,
//   minheight,
//   placeholder = "",
//   marginLeft,
//   marginTop,
//   position,
// }) {
//   const [isActive, setIsActive] = useState(false);
//   const [selectedLabel, setSelectedLabel] = useState("");
//   const dropdownRef = useRef(null);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsActive(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [dropdownRef]);

//   const handleClick = (option) => {
//     setSelected(option.id);
//     setIsActive(false);
//     setSelectedLabel(option.label);
//   };

//   useEffect(() => {
//     // Safely handle undefined or empty options
//     if (options && options.length > 0) {
//       const selectedOption = options.find((option) => option.id === selected);
//       if (selectedOption) {
//         setSelectedLabel(selectedOption.label);
//       } else {
//         setSelectedLabel(""); // Reset if no matching option is found
//       }
//     } else {
//       setSelectedLabel(""); // Reset if options are undefined or empty
//     }
//   }, [selected, options]);

//   return (
//     <div className="dropdown" style={{ width, marginLeft, marginTop}} ref={dropdownRef}>
//       <label>
//         {label}
//         {isRequired && <span>*</span>}
//       </label>
//       <div className="dropdown-btn" onClick={() => setIsActive(!isActive)}>
//         {/* {selectedLabel} */}
//         {selectedLabel || placeholder}
//         <img src={DropDownIcon} alt="dropdown-icon" />
//       </div>
//       {isActive && (
//         <div
//           className="dropdown-content"
//           style={{
//             width: customWidth,
//             top: customTop,
//             maxHeight: minheight,
//             height: Height,
//             overflow: OverFlow,
//             position: position,
//           }}
//         >
//           {options.map((option) => (
//             <div
//               key={option.id}
//               className="dropdown-item"
//               onClick={() => handleClick(option)}
//             >
//               {option.label}
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }







import React, { useState, useRef, useEffect } from "react";
import DropDownIcon from "../../../Assets/Images/EployeeRegistration/icon-dropdown-menu.png";

export default function SectionSelectedDropdown({
  width,
  label,
  selected,
  setSelected,
  options,
  customWidth,
  customTop,
  isRequired,
  Height,
  OverFlow,
  minheight,
  placeholder = "",
  marginLeft,
  marginTop,
  position,
  disabled = false, 
}) {
  const [isActive, setIsActive] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState("");
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsActive(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClick = (option) => {
    if (disabled) return;
    setSelected(option.id);
    setIsActive(false);
    setSelectedLabel(option.label);
  };

  useEffect(() => {
    if (options && options.length > 0) {
      const selectedOption = options.find((option) => option.id === selected);
      if (selectedOption) {
        setSelectedLabel(selectedOption.label);
      } else {
        setSelectedLabel("");
      }
    } else {
      setSelectedLabel("");
    }
  }, [selected, options]);

  return (
    <div
      className="dropdown"
      style={{ width, marginLeft, marginTop }}
      ref={dropdownRef}
    >
      <label>
        {label}
        {isRequired && <span>*</span>}
      </label>
      <div
        className="dropdown-btn"
        onClick={() => {
          if (!disabled) setIsActive(!isActive);
        }}
        style={{
          // cursor: disabled ? "not-allowed" : "pointer",
          opacity: disabled ? 0.6 : 1,
        }}
      >
        {selectedLabel || placeholder}
        <img src={DropDownIcon} alt="dropdown-icon" />
      </div>
      {isActive && !disabled && (
        <div
          className="dropdown-content"
          style={{
            width: customWidth,
            top: customTop,
            maxHeight: minheight,
            height: Height,
            overflow: OverFlow,
            position: position,
          }}
        >
          {options.map((option) => (
            <div
              key={option.id}
              className="dropdown-item"
              onClick={() => handleClick(option)}
              style={{
                cursor: disabled ? "not-allowed" : "pointer",
                opacity: disabled ? 0.6 : 1,
              }}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}






